import React from 'react'

import {
	actionsColumn,
	conditionNameColumn,
	mainProviderColumn,
	mainSiteColumn,
	providersColumn,
	sitesColumn
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import priceComparisonColumn from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Table/columns/comparison"
import CreateAlertsButton from "Pages/ReportsAlerts/Alerts/Conditions/CreateAlerts"
import { dsColorNew } from "@palette"


export default function PriceComparisonTable({ data, isLoading, onDeleteAlert, onEditAlert, filterConditions }) {

	return <AlertsBaseTable
		createButton={<CreateAlertsButton/>}
		title="Alerts: Price Comparison"
		data={data}
		isLoading={isLoading}
		filterConditions={filterConditions}
		columns={[
			conditionNameColumn(),
			mainSiteColumn(),
			mainProviderColumn(),
			priceComparisonColumn(),
			...sitesColumn(),
			providersColumn(),
			actionsColumn(onDeleteAlert, onEditAlert)]}
		legend={[
			{
				icon: "percent",
				value: "%",
				label: "Percentage"
			},
			{
				icon: "money-bills",
				value: "$",
				label: "Currency",
				iconProps: { color: dsColorNew.successText }
			},
			{
				icon: "chart-line-down",
				value: "Cheaper",
				label: "Cheaper",
				iconProps: { color: dsColorNew.dangerRed }
			},
			{
				icon: "chart-line-up",
				value: "More expensive",
				label: "More Expensive",
				iconProps: { color: dsColorNew.successText }
			},
			{
				icon: "chart-line-up-down",
				value: "Cheaper/More expensive",
				label: "Price Difference",
				iconProps: { color: dsColorNew.noteAmber }
			},
		]}
	/>
}